/** Persisted theme preference. `light` keeps the mixed (dark sidenav) look for existing users. */
export type ThemeMode = 'light' | 'light-full' | 'dark';

/**
 * Zustand persist storage key for the UI store (`themeMode`, sidenav, …).
 * The blocking theme script in index.html must read this same key.
 */
export const UI_STORE_PERSIST_NAME = 'app.ui';

/** True when the app canvas uses the dark MUI theme. */
export function isDarkThemeMode(mode: ThemeMode): boolean {
  return mode === 'dark';
}

/**
 * Maps app theme mode to the binary light/dark value expected by external surfaces
 * (e.g. the video editor), which do not understand `light-full`.
 */
export function toBinaryThemeMode(mode: ThemeMode): 'light' | 'dark' {
  return mode === 'dark' ? 'dark' : 'light';
}

/**
 * Returns the initial theme mode when no persisted value exists.
 * Defaults to light (does not follow OS) so first visits / incognito match the boot splash.
 */
export function getInitialThemeMode(): ThemeMode {
  return 'light';
}
